import type { ReactNode } from "react";
import { cn } from "../utils/cn";

type SidebarItem = {
  id: string;
  label: string;
  icon: ReactNode;
  active?: boolean;
  onClick?: () => void;
};

type EntityWorkspaceSidebarProps = {
  items: SidebarItem[];
  isExpanded: boolean;
  footer?: ReactNode;
};

export function EntityWorkspaceSidebar({ items, isExpanded, footer }: EntityWorkspaceSidebarProps) {
  return (
    <>
      <nav className="space-y-1">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            className={cn(
              "group flex w-full items-center gap-2 rounded-md px-2 py-2 text-sm text-text transition duration-150 ease-out",
              "hover:bg-surface-subtle hover:-translate-y-0.5",
              item.active && "bg-surface-subtle border-l-[3px] border-primary",
              !isExpanded && "justify-center"
            )}
            onClick={item.onClick}
            aria-label={item.label}
          >
            <span className="relative">
              <span className="text-base">{item.icon}</span>
              {!isExpanded ? (
                <span className="pointer-events-none absolute left-full top-1/2 z-10 ml-2 -translate-y-1/2 rounded-md border border-border bg-surface px-2 py-1 text-xs text-text opacity-0 transition group-hover:opacity-100 group-focus-visible:opacity-100">
                  {item.label}
                </span>
              ) : null}
            </span>
            {isExpanded ? <span className="whitespace-nowrap">{item.label}</span> : null}
          </button>
        ))}
      </nav>
      {footer ? <div className="mt-4">{footer}</div> : null}
    </>
  );
}
